export class PlattedLotResultDto {
    lotCount: number;
    percentage: number;
    label: string;
    title: string;
}
